import {
  DeleteRequestResponseDTO,
  GetListContentTypesResponseDTO,
  GetListRequestResponseDTO,
  GetRequestDetailResponseDTO,
  PatchRequestResponseDTO,
  PutRequestCloseResponseDTO
} from '@twygs/shared/publisher-interface';
import axiosInstance from './axios-instance';

export const createRequest = async (payload) => {
  const result: GetRequestDetailResponseDTO = await axiosInstance.post(
    `/api/v1/publisher/requests`,
    {
      ...payload
    }
  );
  return result.data;
};

export const updateRequest = async (requestId, payload) => {
  const result: PatchRequestResponseDTO = await axiosInstance.patch(
    `/api/v1/publisher/requests/${requestId}`,
    {
      ...payload
    }
  );
  return result.data;
};

export const fetchListRequests = async (pagination) => {
  const result: GetListRequestResponseDTO = await axiosInstance.get(`/api/v1/publisher/requests`, {
    params: pagination
  });
  return result.data;
};

export const fetchRequestDetail = async (id) => {
  const result: GetRequestDetailResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/requests/${id}/detail`
  );
  return result.data;
};

export const fetchRequestContentTypes = async (pagination) => {
  const result: GetListContentTypesResponseDTO = await axiosInstance.get(
    `/api/v1/publisher/requests/content-types`,
    {
      params: pagination
    }
  );
  return result.data;
};

export const deleteRequest = async (id) => {
  try {
    const result: DeleteRequestResponseDTO = await axiosInstance.delete(
      `/api/v1/publisher/requests/${id}`
    );
    return result.data;
  } catch (error) {
    console.error('Error deleting requests:', error);
    throw error;
  }
};

export const closeRequest = async (id) => {
  const result: PutRequestCloseResponseDTO = await axiosInstance.put(
    `/api/v1/publisher/requests/${id}/mark-as-closed`
  );
  return result.data;
};
